export default __webpack_public_path__ + "static/media/policeman.89724798.png";